import { apolloClientService } from '../../../../services/apollo-client';

async function fetchChartData(accountId, saId, startDate, endDate, displayMode, mode) {
    let APIquery = `
        { getUsageTrends(input: {displayMode: "` + displayMode + `",startDate:"` + startDate + `",endDate:"` + endDate + `",
            additionalIdentifiers: [
                {
                    name: "mode",
                    value: "`+ mode + `"
                }
            ]
        }) { 
            usageQuantity { 
                intervalName 
                intervalShortName 
                intervalDateTime 
                quantity
                noData
                usageDate
            } 
            usageUnit 
        }
    }`
    let headers = {
        saId: saId,
        accountId: accountId
    }
    return await apolloClientService.ApolloClientgqlsUsage(APIquery, headers, "network-only");
}

export const usageService = { fetchChartData };